import { useEffect, useRef } from 'react'

// 찾기/바꾸기(FindReplace) 도우미 — 팝업 닫기, 선택 영역 범위, 찾을 글자 패턴

/** 바깥 클릭·Esc 로 닫히는 팝업 */
export function useOutsideClose(onClose: () => void) {
  const ref = useRef<HTMLDivElement>(null)
  const closeRef = useRef(onClose)
  useEffect(() => { closeRef.current = onClose })
  useEffect(() => {
    const onDown = (e: MouseEvent) => { if (ref.current && !ref.current.contains(e.target as Node)) closeRef.current() }
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') closeRef.current() }
    const t = setTimeout(() => window.addEventListener('mousedown', onDown))
    window.addEventListener('keydown', onKey)
    return () => { clearTimeout(t); window.removeEventListener('mousedown', onDown); window.removeEventListener('keydown', onKey) }
  }, [])
  return ref
}

/** 찾은 칸 — 시트(디바이스·인터페이스 키)·행·칸 이름과 그 칸에서 찾은 횟수 */
export interface FindHit { sheet: string; row: number; field: string; count: number }

/** 표에서 고른 영역 — 찾기를 열 때 잡아 둔다 (팝업을 여는 동안 표에서 커서를 빼므로) */
export interface FindSelection { sheetKey: string; rows: [number, number]; fields: string[] }

/** 여러 칸을 골랐을 때만 선택 영역으로 본다 (엑셀처럼 한 칸이면 시트 전체) */
export function toFindSelection(sheetKey: string | undefined, sel: { min: { col: number; row: number }; max: { col: number; row: number } } | null | undefined,
  fieldAt: (col: number) => string | undefined): FindSelection | null {
  if (!sheetKey || !sel || (sel.min.col === sel.max.col && sel.min.row === sel.max.row)) return null
  const fields: string[] = []
  for (let c = sel.min.col; c <= sel.max.col; c++) { const f = fieldAt(c); if (f) fields.push(f) }
  return { sheetKey, rows: [sel.min.row, sel.max.row], fields }
}

export const selectionLabel = (s: FindSelection) => `선택 영역 (${s.rows[1] - s.rows[0] + 1}행 × ${s.fields.length}열)`

export const findPattern = (find: string) => (find ? new RegExp(find.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi') : null)
